"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferUntil = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
// Buffer values until the closing observable emits, then emit buffered values and switch to original stream
function bufferUntil(closing) {
    return stream => stream.pipe(operators_1.bufferToggle(rxjs_1.of(false), () => closing), operators_1.switchMap(initial => rxjs_1.concat(rxjs_1.from(initial), stream)));
}
exports.bufferUntil = bufferUntil;
//# sourceMappingURL=buffer-until.js.map